// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Usp__componentWrapper-hcnL","component":"Usp__component-Yc5D","usp":"Usp__usp-sL3h","icon":"Usp__icon-rqOg"};